import { useModalVisibility } from '@app/utils/hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../Button';
import { Barcode } from '../Icons';
import { Tooltip } from '../Tooltip';

interface Props {
  onShowBarcodeScanner?: VoidFunction;
}

export const BarcodeScannerButton = ({ onShowBarcodeScanner }: Props) => {
  const { t } = useTranslation(['common']);
  const { showModal } = useModalVisibility('BarcodeScannerModal');

  const handleClick = React.useCallback(() => {
    onShowBarcodeScanner?.();
    showModal();
  }, [onShowBarcodeScanner, showModal]);

  return (
    <Tooltip content={t('common:barcode_scanner')} disableOnTouchScreen>
      <Button
        type="button"
        size="medium"
        color="secondary"
        variant="flat"
        aria-label={t('common:barcode_scanner')}
        onClick={handleClick}
        icon={Barcode}
      />
    </Tooltip>
  );
};
